<div *ngIf="getDeviceTypeById$ | async as getDeviceTypeById; else loading">
    <img [src]="getDeviceTypeById.iconURL" alt="Icon" class="image"> {{getDeviceTypeById.key}}
</div>

<ng-template #loading >
    <mat-spinner [diameter]="30" ></mat-spinner>
</ng-template>